// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"114ceb94","880":"1b9a57f1"}[chunkId] + ".chunk.css";
};